import { defineMessages } from 'react-intl';

export const quantitySelectionMessages = defineMessages({
  label: {
    id: 'quantitySelection.label',
    defaultMessage: 'Anzahl',
  },
});
